import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  as: Tag = 'div',
}) => (
  <Tag className={`max-w-v2 mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </Tag>
);
